import {Model} from "@tailflow/laravel-orion/lib/model";

export default class Site extends Model<{}> {
    public $resource(): string {
        return "sites";
    }

    public $getKeyName() : string {
        return 'id';
    }
}